import { useCallback } from "react";
import SupportPromptGroup from "@amzn/awsui-chat-components-console/support-prompt-group";

import { getString } from '../../../common/ui-string-labels/ui-strings-utils';
import chatbotConfig from "../chatbot-config.json";
import { SupportPromptClickEvent } from "../interfaces";

interface SupportPromptsProps {
    onSend: (message: string) => void;
}

const SupportPrompts = ({ onSend }: SupportPromptsProps) => {
    const handleClick = useCallback((event: SupportPromptClickEvent) => {
        const prompt = chatbotConfig.supportPrompts.find((p) => p.id === event.detail.id);
        if (prompt) onSend(prompt.query);
    }, [onSend]);

    return (
        <SupportPromptGroup
            ariaLabel={getString('chatbot.input.quickActionsAriaLabel')}
            alignment="horizontal"
            items={chatbotConfig.supportPrompts}
            onItemClick={handleClick}
        />
    );
};

export default SupportPrompts;
